import React, { useEffect, useState, useRef } from 'react';
import { TYPE } from "./index";
import { imageBaseUrl } from "../utils/variables";
var Dates = function (props) {
    var _a = useState(props.selectedItem), clickedIndex = _a[0], setClickedIndex = _a[1];
    var itemsRef = useRef({});
    var moveIndexInToView = function (index, behavior) {
        if (behavior === void 0) { behavior = "smooth"; }
        itemsRef.current[index].click();
        itemsRef.current[index].scrollIntoView({ block: "center", behavior: behavior });
    };
    useEffect(function () {
        moveIndexInToView(props.selectedItem, "auto");
    }, []);
    var selectItem = function (item, index) {
        props.type === TYPE.MONTH ? props.handleChange(TYPE[props.type], index) : props.handleChange(TYPE[props.type], item);
        setClickedIndex(index);
        itemsRef.current[index].scrollIntoView({ block: "center", behavior: "smooth" });
    };
    var handleUpArrow = function () {
        (clickedIndex > props.pickerItem.length - 1 || clickedIndex < 0) ? moveIndexInToView(0) :
            (clickedIndex > 0) ? moveIndexInToView(clickedIndex - 1) : moveIndexInToView(props.pickerItem.length - 1);
    };
    var handleDownArrow = function () {
        (clickedIndex < props.pickerItem.length - 1) ? moveIndexInToView(clickedIndex + 1) : moveIndexInToView(0);
    };
    return (React.createElement("div", { className: "middle_item_wraper" },
        React.createElement("div", { onClick: function () { return handleUpArrow(); }, className: "updawnArrow" },
            React.createElement("img", { src: "".concat(imageBaseUrl, "/img/icons/up.svg"), height: "15px", alt: "up_arrow_icon" })),
        React.createElement("div", { className: "item-container" }, props.pickerItem.map(function (item, index) {
            return (React.createElement("div", { className: "items ".concat(clickedIndex === index ? "clicked" : ""), ref: function (element) { return itemsRef.current[index] = element; }, key: index, onClick: function () { return selectItem(item, index); } }, props.type === TYPE.DATE ? "0".concat(item).slice(-2) : item));
        })),
        React.createElement("div", { onClick: function () { return handleDownArrow(); }, className: "updawnArrow" },
            React.createElement("img", { src: "".concat(imageBaseUrl, "/img/icons/down.svg"), height: "15px", alt: "up_arrow_icon" }))));
};
export default Dates;
//# sourceMappingURL=DatePickerItem.js.map